export const ENV = {
    dev: 'https://testapi.ileero.com/v1/graphql',
    prod: 'https://api.ileero.com/v1/graphql',
    shuftipro: {
        clienId: 'tyxKPheSuQTMwaATQDAIjvbsMCvdJYFJL1XvRoeXyi72icTif51612548897',
        secretKey: '$2y$10$zsfAessYMPp4liDsNDViwuhw4Qq04JNztulDmaJ1V0DPy7McBACY2'
    },
    apiKey: 'vDxbYKIEhB4JD0RmNgFDNcYdET90kSF89ncychFe'
}


// export const ENV = {
//   dev: process.env.DEV,
//   prod: process.env.PROD,
//   shuftipro: {
//     clienId: process.env.SHUFTI_PRO_CLIEND_ID,
//     secretKey: process.env.SHUFTI_PRO_SECRET_KEY,
//   },
//   apiKey: process.env.API_KEY,
// };